<template>
    <button @click="showNewMessage" class="flex items-center gap-1 font-medium decoration-1 decoration-dotted underline underline-offset-4 hover:decoration-solid hover:text-red">
        <BaseSvg name="icon-chat-bubble" class="w-4 h-4" />
        <span>{{ $t(text) }}</span>
    </button>
</template>

<script setup>
import {BaseSvg} from "@/Components";
import {useChat} from "@/Composables";
const { showNewMessage } = useChat();

const props = defineProps({
    text: {
        type: String,
        required: false,
        default: 'Chat',
    },
})
</script>
